import React, { useEffect, useRef } from "react";
import { Images, Services } from "../../../Controller";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setselectedTab } from "../../../Store/B2bslice";
function AepsBankingServiceMain() {
  const profiledetail = useSelector((state) => state.B2B.profileDetail);
  const memberServices = useSelector((state) => state.B2B.memberServices);
  const dispatch = useDispatch();

  const checkDigiStatus = () => {
    if (
      profiledetail.digio_kyc === "0" ||
      profiledetail.digio_kyc === "2" ||
      profiledetail.digio_kyc === "3"
    ) {
      return true;
    }
  };
  const checkStatus = (to) => {
    if (!profiledetail.aeps_onboard) {
      return "/banking/aeps-onboard";
    } else if (!profiledetail.ekyc_status) {
      return "/banking/aeps-ekyc";
    } else if (!profiledetail.twofa_status) {
      return "/banking/aeps";
    } else {
      return to;
    }
  };
  const checkCredoStatus = () => {
    if (!profiledetail.credo_aeps_onboard) {
      return "/banking/aeps2-onboard";
    } else if (!profiledetail.credo_aeps_status) {
      return "/banking/waiting";
    } else if (
      profiledetail.credo_aeps_onboard &&
      profiledetail.credo_aeps_status
    ) {
      return "/banking/aeps2-2fa";
    }
  };
  const navigate = useNavigate();

  const checkWithdrawalStatus = (to) => {
    if (!profiledetail.aeps_onboard) {
      return "/banking/aeps-onboard";
    } else if (!profiledetail.ekyc_status) {
      return "/banking/aeps-ekyc";
    } else if (!profiledetail.twofa_status) {
      return "/banking/aeps";
    }
    //  else if (withdrawalTime === 0) {
    //   return "/banking/aeps";
    // }
    else {
      return to;
    }
  };

  const checkEkoStatus = (to) => {
    if (!profiledetail.eko_aeps_service_status == 1) {
      return "/banking/aeps-eko-onboard";
    } else if (!profiledetail.eko_aeps_ekyc_status) {
      return "/banking/aeps-eko-ekyc";
    } else if (!profiledetail.twofa_status) {
      return "/banking/aeps-eko";
    } else {
      return to;
    }
  };
  useEffect(() => {
    dispatch(setselectedTab("117"));
  }, []);
  return (
    <div className="m-4">
      {" "}
      <div className="grid grid-cols-1  md:grid-cols-3  place-items-start gap-3">
        {memberServices.includes("8") && (
          <div className="shadow-[0px_2px_2px_#ccdcff] p-2 border-rgbaprimary9 border-b-2 bg-white text-center  w-full rounded-xl cursor-pointer">
            <p className="text-rgbaprimary7 text-base leading-5 font-bold mt-4">
              AEPS
            </p>
            <div className="grid grid-cols-1 gap-4 mt-4">
              <div
                className=" bg-primary rounded-xl cursor-pointer border-rgbaprimary9 border-t-2  justify-items-center"
                onClick={() =>
                  navigate(
                    checkDigiStatus()
                      ? "/kycStatus"
                      : memberServices.includes("8")
                        ? checkWithdrawalStatus("/banking/aeps-cash-withdrawl")
                        : "/not-available",
                    {
                      state: {
                        from: "/banking/aeps-cash-withdrawl",
                        type: "aeps",
                      },
                    },
                  )
                }
              >
                <p className="text-white text-base font-bold p-2 ">
                  Cash Withdrawal
                </p>
              </div>

              <div
                className=" bg-primary rounded-xl cursor-pointer border-rgbaprimary9 border-t-2  justify-items-center"
                onClick={() =>
                  navigate(
                    checkDigiStatus()
                      ? "/kycStatus"
                      : memberServices.includes("8")
                        ? checkWithdrawalStatus("/banking/aeps-aadharpay")
                        : "/not-available",
                    {
                      state: {
                        from: "/banking/aeps-aadharpay",
                        type: "aadhar_pay",
                      },
                    },
                  )
                }
              >
                <p className="text-white text-base font-bold p-2 text-center">
                  Aadhaar Pay
                </p>
              </div>

              <div
                className=" bg-primary rounded-xl cursor-pointer border-rgbaprimary9 border-t-2  justify-items-center"
                onClick={() =>
                  navigate(
                    checkDigiStatus()
                      ? "/kycStatus"
                      : memberServices.includes("8")
                        ? checkStatus("/banking/aeps-miniStatement")
                        : "/not-available",
                    {
                      state: {
                        from: "/banking/aeps-miniStatement",
                        type: "aeps",
                      },
                    },
                  )
                }
              >
                <p className="text-white text-base font-bold p-2 text-center">
                  Mini Statement
                </p>
              </div>

              <div
                className=" bg-primary rounded-xl cursor-pointer border-rgbaprimary9 border-t-2  justify-items-center"
                onClick={() =>
                  navigate(
                    checkDigiStatus()
                      ? "/kycStatus"
                      : memberServices.includes("8")
                        ? checkStatus("/banking/aeps-balanceEnquiry")
                        : "/not-available",
                    {
                      state: {
                        from: "/banking/aeps-balanceEnquiry",
                        type: "aeps",
                      },
                    },
                  )
                }
              >
                <p className="text-white text-base font-bold p-2 text-center">
                  Balance Enquiry
                </p>
              </div>
            </div>
          </div>
        )}
        {memberServices.includes("25") && (
          <div className="shadow-[0px_2px_2px_#ccdcff] p-2 border-rgbaprimary9 border-b-2 bg-white h-18 text-center w-full rounded-xl cursor-pointer">
            <p className="text-rgbaprimary7 text-base leading-5 font-bold mt-4">
              AEPS 2
            </p>
            <div className="grid grid-cols-1 gap-4 mt-4">
              <div
                className=" bg-primary rounded-xl cursor-pointer border-rgbaprimary9 border-t-2  justify-items-center"
                onClick={() =>
                  navigate(
                    memberServices.includes("25")
                      ? checkCredoStatus()
                      : "/not-available",
                  )
                }
              >
                <p className="text-white text-base font-bold p-2 ">AEPS 2</p>
              </div>
            </div>
          </div>
        )}
        {memberServices.includes("114") && (
          <div className="shadow-[0px_2px_2px_#ccdcff] p-2 border-rgbaprimary9 border-b-2 bg-white text-center  w-full rounded-xl cursor-pointer">
            <p className="text-rgbaprimary7 text-base leading-5 font-bold mt-4">
              AEPS 3
            </p>
            <div className="grid grid-cols-1 gap-4 mt-4">
              <div
                className=" bg-primary rounded-xl cursor-pointer border-rgbaprimary9 border-t-2  justify-items-center"
                onClick={() =>
                  navigate(
                    memberServices.includes("114")
                      ? checkEkoStatus("/banking/aeps-eko-cash-withdrawl")
                      : "/not-available",
                    {
                      state: {
                        from: "/banking/aeps-cash-withdrawl",
                        type: "aeps",
                      },
                    },
                  )
                }
              >
                <p className="text-white text-base font-bold p-2 ">
                  Cash Withdrawal
                </p>
              </div>

              <div
                className=" bg-primary rounded-xl cursor-pointer border-rgbaprimary9 border-t-2  justify-items-center"
                onClick={() =>
                  navigate(
                    memberServices.includes("114")
                      ? checkEkoStatus("/banking/aeps-eko-miniStatement")
                      : "/not-available",
                    {
                      state: {
                        from: "/banking/aeps-miniStatement",
                        type: "aeps",
                      },
                    },
                  )
                }
              >
                <p className="text-white text-base font-bold p-2 text-center">
                  Mini Statement
                </p>
              </div>

              <div
                className=" bg-primary rounded-xl cursor-pointer border-rgbaprimary9 border-t-2  justify-items-center"
                onClick={() =>
                  navigate(
                    memberServices.includes("114")
                      ? checkEkoStatus("/banking/aeps-eko-balanceEnquiry")
                      : "/not-available",
                    {
                      state: {
                        from: "/banking/aeps-balanceEnquiry",
                        type: "aeps",
                      },
                    },
                  )
                }
              >
                <p className="text-white text-base font-bold p-2 text-center">
                  Balance Enquiry
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
export default AepsBankingServiceMain;
